import { combineReducers } from '@reduxjs/toolkit';
import { modalCopyMessage } from './modal-message-copy';

export { useLoadWebsettings } from './load-websettings';
export { useLoadCommonSettings } from './load-settings';
export { useLoadTags } from './load-tags';
export { useFilter, Filter, Search } from './filter-list';
export { useModalCopyMessage, ModalMessageCopy } from './modal-message-copy';
export { useLoadGroups } from './load-groups';
export { useLoadClients } from './load-clients';
export { useLoadColorTags } from './load-color-tags';

export { Logo } from './logo';
export { ProtectedAuthRoute } from './protected-auth-route';

export const commonFeatures = combineReducers({ modalCopyMessage: modalCopyMessage.reducer });
